import {
    IsIn,
    IsBoolean,
    IsEmail,
    IsEnum,
    IsNotEmpty,
    IsOptional,
    IsPhoneNumber,
    IsString,
    ValidateIf,
} from 'class-validator';
import i18n from 'src/i18n';
import { NextOfKinRelationType } from 'src/domain/next-of-kin';

export class NextOfKinFormSchema {
    @IsString()
    @IsNotEmpty({ message: () => i18n.t('validation.requiredField') })
    firstName!: string;

    @IsString()
    @IsNotEmpty({ message: () => i18n.t('validation.requiredField') })
    lastName!: string;

    @IsOptional()
    @ValidateIf(o => o.phoneNumber?.length !== 0)
    @IsNotEmpty({ message: () => i18n.t('validation.requiredField') })
    @IsPhoneNumber('NO', { message: () => i18n.t('validation.invalidPhone') })
    phoneNumber?: string;

    @ValidateIf(o => !o.phoneNumber || Boolean(o.email?.trim()))
    @IsEmail({}, { message: () => i18n.t('validation.invalidEmail') })
    email?: string;

    @IsOptional()
    @IsIn(['email', 'phone'])
    invitationMethod?: 'email' | 'phone';

    @IsNotEmpty({ message: () => i18n.t('validation.requiredField') })
    @IsEnum(NextOfKinRelationType)
    relation!: NextOfKinRelationType;

    @IsOptional()
    isMainContact?: boolean;

    @IsOptional()
    @IsBoolean()
    isGuardian?: boolean;

    @IsOptional()
    @ValidateIf(o => o.isMainContact)
    @IsBoolean()
    disableManagingRelatives?: boolean;
}

export type NextOfKinFormValues = {
    firstName: string;
    lastName: string;
    phoneNumber?: string;
    email?: string;
    invitationMethod?: 'email' | 'phone';
    relation: NextOfKinRelationType;
    isMainContact?: boolean;
    isGuardian?: boolean;
    disableManagingRelatives?: boolean;
};

export class NextOfKinEditSchema {
    @IsString()
    @IsNotEmpty({ message: () => i18n.t('validation.requiredField') })
    firstName!: string;

    @IsString()
    @IsNotEmpty({ message: () => i18n.t('validation.requiredField') })
    lastName!: string;

    @IsNotEmpty({ message: () => i18n.t('validation.requiredField') })
    @IsEnum(NextOfKinRelationType)
    relation!: NextOfKinRelationType;

    @IsOptional()
    isMainContact?: boolean;

    @IsOptional()
    @IsBoolean()
    isGuardian?: boolean;

    @IsOptional()
    @ValidateIf(o => o.isMainContact)
    @IsBoolean()
    disableManagingRelatives?: boolean;
}

export type NextOfKinEditValues = Pick<
    NextOfKinFormValues,
    | 'firstName'
    | 'lastName'
    | 'relation'
    | 'isMainContact'
    | 'isGuardian'
    | 'disableManagingRelatives'
>;
